class ProductPurchaseState extends HTMLElement {
  connectedCallback() {
    const data = window.TimesactData;
    this.managed = data && !data.appDisabled && !data.useCustomScript &&
      String(data.product?.id) === this.dataset.productId &&
      (data.product.variants.some(variant => variant.experienceIds?.length) ||
        Object.values(data.experiences).some(experience =>
          experience.backInStockStoreLevelEnabled || experience.lowStockStoreLevelEnabled));

    if (!this.managed) {
      this.release();
      return;
    }

    this.variant = { id: Number(this.querySelector('[data-product-select]')?.value) };
    this.observer = new MutationObserver(() => {
      const button = this.querySelector('[data-add-to-cart]');
      if (this.button && (button !== this.button || button.textContent !== this.buttonText)) {
        this.updateVariant(this.variant);
      }
    });
    this.observer.observe(this, { childList: true, subtree: true, characterData: true });
    this.updateVariant(this.variant);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    clearInterval(this.waitTimer);
    clearTimeout(this.fallbackTimer);
  }

  updateVariant(variant) {
    if (!this.managed || !variant?.id) {
      this.release();
      return false;
    }
    this.variant = variant;
    const app = window.TimesactApp;
    const handler = app?.pageHandler;
    if (!handler || typeof handler._applyFeaturesForVariant !== 'function' ||
        !app.dataManager.hasVariantData(variant.id)) {
      this.dataset.purchaseState = 'pending';
      this.setAttribute('aria-busy', 'true');
      if (!this.waitTimer) {
        this.waitTimer = setInterval(() => this.updateVariant(this.variant), 50);
        this.fallbackTimer = setTimeout(() => this.release(), 5000);
      }
      return false;
    }

    try {
      handler.currentVariantId = variant.id;
      handler._applyFeaturesForVariant(variant.id);
      const features = app.dataManager.getActiveFeatures(variant.id);
      this.dataset.purchaseMode = features.some(feature => feature.type === 'preOrder') ? 'preorder' :
        features.some(feature => feature.type === 'backInStock' || feature.type === 'comingSoon') ? 'unavailable' : 'regular';
      this.button = this.querySelector('[data-add-to-cart]');
      this.buttonText = this.button?.textContent;
      this.release();
      return true;
    } catch (error) {
      this.release();
      console.error(error);
      return false;
    }
  }

  release() {
    clearInterval(this.waitTimer);
    clearTimeout(this.fallbackTimer);
    this.waitTimer = null;
    this.dataset.purchaseState = 'ready';
    this.removeAttribute('aria-busy');
  }
}

if (!customElements.get('product-purchase-state')) {
  customElements.define('product-purchase-state', ProductPurchaseState);
}
